//@flow
import * as Immutable from 'immutable';

import {
    PjpInsightsDashboard,
    PjpInsightsDashboardData
} from 'common/models/flow/PjpInsightsDashboard';
import type {
    PjpInsightsDashboardModelType,
    PjpInsightsDashboardDataModelType
} from 'common/models/flow/PjpInsightsDashboard';
import { PjpMetricGraph } from 'common/models/internal/PjpMetricGraph';

class InternalPjpInsightsDashboard extends PjpInsightsDashboard {
    static fromJS(
        json: PjpInsightsDashboardModelType
    ): InternalPjpInsightsDashboard {
        const state: Object = Object.assign({}, json);
        state.dashboardData = InternalPjpInsightsDashboardData.fromJS(
            state.dashboardData
        );
        return new this(Immutable.Map(state));
    }

    get dashboardData(): InternalPjpInsightsDashboardData {
        return this._state.get('dashboardData');
    }
}

class InternalPjpInsightsDashboardData extends PjpInsightsDashboardData {
    static fromJS(
        json: PjpInsightsDashboardDataModelType
    ): InternalPjpInsightsDashboardData {
        const state: Object = Object.assign({}, json);
        state.graphs = Immutable.List(state.graphs).map(item =>
            PjpMetricGraph.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    get graphs(): Immutable.List<PjpMetricGraph> {
        return this._state.get('graphs');
    }
}

export {
    InternalPjpInsightsDashboard as PjpInsightsDashboard,
    InternalPjpInsightsDashboardData as PjpInsightsDashboardData
};
